import classNames from "classnames";
import { observable, runInAction } from "mobx";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { changeCoopState } from "../../../../stores/GlobalState";
import { SolutionTab } from "../../about/Solutions";
import "./index.scss";

export const FormState = observable({
  link: "",
});

const Arrange = observer(
  ({ content, linkblock }: { content: any; linkblock: string }) => {
    const [tab, setTab] = useState(0);
    const [width, setWidth] = useState(window.innerWidth);
    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
      window.addEventListener("resize", () => setWidth(window.innerWidth));
    }, []);

    return (
      <section
        className={classNames(
          "things-arrange"
          // pathname.includes('business') && 'dark-theme',
        )}
      >
        <div className="things-arrange__row">
          <div className="things-arrange__col">
            {" "}
            <div className="things-arrange__title">{content.title}</div>
            {width <= 760 ? (
              <div className="things-arrange__tabs">
                {content.tabs.map((l: any, i: number) => (
                  <SolutionTab
                    title={l.title}
                    key={i}
                    active={tab == i}
                    setTab={(value) => setTab(i)}
                  />
                ))}
              </div>
            ) : (
              <></>
            )}
            {width > 760 ? (
              <div className="things-arrange__img">
                <img src={content.tabs[tab].img} />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="things-arrange__col">
            {width > 760 ? (
              <div className="things-arrange__tabs">
                {content.tabs.map((l: any, i: number) => (
                  <SolutionTab
                    title={l.title}
                    key={i}
                    active={tab == i}
                    setTab={(value) => setTab(i)}
                  />
                ))}
              </div>
            ) : (
              <></>
            )}
            {width <= 760 ? (
              <div className="things-arrange__img">
                <img src={content.tabs[tab].mobImg} />
              </div>
            ) : (
              <></>
            )}
            <div className="things-arrange__list">
              {content.tabs[tab].list.map((ci: any, i: number) => (
                <div className="things-arrange__item" key={i}>
                  <div className="things-arrange__item-num">{i + 1}</div>
                  <div
                    className="things-arrange__item-text"
                    dangerouslySetInnerHTML={{ __html: ci }}
                  >
                  </div>
                </div>
              ))}
            </div>
            {content.tabs[tab].buttonLink.includes("#coop") ? (
              <div
                className="button black"
                onClick={() => {
                  if (
                    [
                      "freight",
                      "mizhnarodnyi-khab",
                      "end2end-dostavka",
                    ].includes(
                      linkblock
                        .replaceAll("/for-you/", "")
                        .replaceAll("/for-business/", "")
                    )
                  ) {
                    runInAction(() => {
                      FormState.link = linkblock
                        .replaceAll("/for-you/", "")
                        .replaceAll("/for-business/", "");
                    });
                  }
                  changeCoopState();
                }}
              >
                {content.tabs[tab].buttonTitle}
              </div>
            ) : (
              <a className="button black" href={content.tabs[tab].buttonLink}>
                {content.tabs[tab].buttonTitle}
              </a>
            )}
          </div>
        </div>
      </section>
    );
  }
);

export default Arrange;
